import React from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import PmaEditor from "./PMAEditor";
import axios from "common/interceptors";
import {
  startPrintFontGate,
  stopPrintFontGate,
  signalPrintReadyIfIdle,
} from "common/utils/pmaPrintReady";

// Wrapper component to use useParams hook
const PrintMarketTrendsPMAWrapper = (props) => {
  const params = useParams();
  return <PrintMarketTrendsPMA {...props} params={params} />;
};

class PrintMarketTrendsPMA extends React.Component {
  state = {
    singleHOData: null,
    agentData: null,
    mlsAreas: null,
    marketActivity: null,
    MQCityDetails: null,
    currentArea: null,
    version: "qv3",
    coverPageDetails: null,
    qArea: null,
    qCity: null,
    aprilData: null,
    fontsReady: false,
    fontsTimedOut: false,
  };

  async componentDidMount() {
    startPrintFontGate(this);
    console.log("inside 2");
    // Get parameters from URL or props
    let mailProId, listgenUserID, brokerage;
    
    if (this.props.params) {
      mailProId = this.props.params.mailproid;
      listgenUserID = this.props.params.listgenUserID;
      brokerage = this.props.params.brokerage;
    } else if (this.props.match && this.props.match.params) {
      mailProId = this.props.match.params.mailproid;
      listgenUserID = this.props.match.params.listgenUserID;
      brokerage = this.props.match.params.brokerage;
    } else {
      // Fallback: extract from URL
      const urlParams = new URLSearchParams(window.location.search);
      mailProId = urlParams.get('mailproid') || this.props.mailproid;
      listgenUserID = urlParams.get('listgenUserID') || this.props.listgenUserID;
      brokerage = urlParams.get('brokerage') || this.props.brokerage;
    }
    
    // Validate required parameters
    if (!mailProId || !listgenUserID) {
      console.error('Missing required parameters: mailProId or listgenUserID');
      return;
    }
    const { version } = this.state;
    let url = window.location.href;
    if (url.includes("test-print")) {
      listgenUserID = url[url.length - 2];
    }
    let date = new Date();
    let thisYear = date.getFullYear();
    const thisMonth = `${date.getMonth() + 1}`.padStart(2, 0);
    const today = `${date.getDate()}`.padStart(2, 0);
    try {
      let mailPrint = await axios
        .get(
          `/admin/getMailPrintInfoDetails?listgenUserID=${listgenUserID}&mailerProID=${mailProId}`,
          {
            headers: {
              "content-type": "application/json",
            },
            data: {},
          }
        )
        .then((res) => {
          const singleHOData = res.data.mailerProDTO;
          const agentData = res.data.listgenUserDTO;
          this.setState({
            singleHOData,
            agentData,
          });
        })
        .catch((err) => console.log("error retrieving idDetails" + err));
    } catch (error) {}
    let navBar = await axios
      .get(`/agent/getNavbarInfo?listgenUserID=${listgenUserID}`, {
        headers: {
          "content-type": "application/json",
        },
        data: {},
      })
      .then((res) => {
        this.setState({
          mlsAreas: res.data,
        });
      })
      .catch((err) => {});
    const thisArea = this.state.singleHOData.areaID;

    const { singleHOData } = this.state;
    let currentArea =
      this.state.mlsAreas.filter((area) => area.mlsAreaID === thisArea)[0] ||
      this.state.mlsAreas[0];
    const { mlsCityID, mlsAreaID } = currentArea;
    // if (mlsAreaID === "DEMO-SCL-17F") {
    //   currentArea.mlsNeighborhood = "Cielito";
    // }
    const { subdivisionName } = singleHOData;

    let getPmaDetails = await axios
      .get(
        `/agent/getPMADetails?areaCityPeriod=${mlsAreaID}-${mlsCityID}-${thisYear}-${thisMonth}-${today}&subDivision=${
          subdivisionName ? subdivisionName : "-"
        }&listgenUserID=${listgenUserID}&mailerProID=${mailProId}`,

        {
          headers: {
            "content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          data: {},
        }
      )
      .then((res) => {
        console.log("inside market trends res.data", res.data);
        const {
          mailerPrintInfoDTO,
          lgTestmonialsDTO,
          missionStatementDTO,
          propertyPhotoDetailsDTO,
        } = res.data;
        const singleHOData = mailerPrintInfoDTO.mailerProDTO;
        const agentData = mailerPrintInfoDTO.listgenUserDTO;
        this.setState({
          singleHOData,
          agentData,
          currentArea,
          coverPageDetails: res.data.pmaCoverPhotoDTO,
          quarterlyAreaTable: res.data.pmaQuarterlyAreaDTO,
          quarterlyCityTable: res.data.pmaQuarterlyCityDTO,
          testimonials: lgTestmonialsDTO,
          propertyPhotoDetailsDTO: propertyPhotoDetailsDTO,
          aprilData: {
            pmaQuarterlyAreaDTO: res.data.pmaQuarterlyAreaDTO,
            pmaQuarterlyCityDTO: res.data.pmaQuarterlyCityDTO,
          },
          bubbleBoxes: res.data.marketValueInfoList,
          testimonials: res.data.lgTestmonialsDTO,
          missionStatement: missionStatementDTO,
        });
      })
      .catch((err) => console.log("error retrieving table bubble data" + err));
  }
  isPrintDataReady = () => {
    const {
      currentArea,
      singleHOData,
      agentData,
      coverPageDetails,
      quarterlyAreaTable,
      bubbleBoxes,
    } = this.state;
    return !!(
      currentArea &&
      singleHOData &&
      agentData &&
      coverPageDetails &&
      quarterlyAreaTable &&
      bubbleBoxes
    );
  };

  componentDidUpdate() {
    signalPrintReadyIfIdle(this, this.isPrintDataReady());
  }

  componentWillUnmount() {
    stopPrintFontGate(this);
  }

  render() {
    const { propertyData } = this.props;
    const {
      singleHOData,
      agentData,
      mlsAreas,
      marketActivity,
      MQCityDetails,
      currentArea,
      version,
      quarterlyCityTable,
      quarterlyAreaTable,
      coverPageDetails,
      qArea,
      qCity,
      aprilData,
      bubbleBoxes,
      fontsReady,
    } = this.state;
    if (this.isPrintDataReady() && fontsReady) {
      return (
        <div className="pma-creator">
          <main>
            <section>
              <PmaEditor
                propertyData={propertyData}
                printVersion={true}
                version={version}
                singleHOData={singleHOData}
                agentData={agentData}
                currentArea={currentArea}
                marketActivity={marketActivity}
                MQCityDetails={MQCityDetails}
                mlsAreas={mlsAreas}
                quarterlyAreaTable={quarterlyAreaTable}
                quarterlyCityTable={quarterlyCityTable}
                coverPageDetails={coverPageDetails}
                qArea={qArea}
                qCity={qCity}
                aprilData={aprilData}
                dontShowPma={false}
                bubbleBoxes={bubbleBoxes}
              />
            </section>
          </main>
        </div>
      );
    } else {
      return <div>Loading PMA...</div>;
    }
  }
}

PrintMarketTrendsPMA.propTypes = {
  params: PropTypes.shape({
    mailproid: PropTypes.string,
    listgenUserID: PropTypes.string,
    brokerage: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      mailproid: PropTypes.string,
      listgenUserID: PropTypes.string,
      brokerage: PropTypes.string,
    }),
  }),
  mailproid: PropTypes.string,
  listgenUserID: PropTypes.string,
  brokerage: PropTypes.string,
};

export default PrintMarketTrendsPMAWrapper;
